import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createTextNode, $getSelection, $isElementNode, $isRangeSelection, KEY_ENTER_COMMAND } from 'lexical';
import { useEffect } from 'react';
import { getHeight, getSelectedPage } from '../nodes/LayoutItemNode';

export function PagePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        editor.update(()=>{
      let totalHeight = 0;
      let overflowTriggerChild: HTMLElement | null = null;
      const selectedPage = getSelectedPage();
      if(!selectedPage) return;
      const pageElem = editor.getElementByKey(selectedPage.getLatest().getKey())
      if(!pageElem) return;
    
      pageElem.childNodes.forEach((child) => {
        if (
          child instanceof HTMLElement &&
          !child.classList.contains('Header-Input') &&
          !child.classList.contains('Footer-Input') &&
          !child.classList.contains('PlaygroundEditorTheme__layoutContainer')
        ) {
          totalHeight += child.offsetHeight;

          if (totalHeight >= 1100 && overflowTriggerChild === null) {
            overflowTriggerChild = (pageElem.lastElementChild as HTMLElement);
          }
        }
      });

      if (totalHeight >= 950 && overflowTriggerChild) {
        pageElem.dispatchEvent(
          new CustomEvent("DivNodeOverflow", {
            detail: {
              key: selectedPage.getLatest().getKey(),
              overflowingContent: selectedPage.getLastChild(),
            },
            bubbles: true,
          })
        );
      }

              const selection = $getSelection();
              if($isRangeSelection(selection)){
                const node = selection.anchor.getNode()
                if( $isElementNode(node) && selection.hasFormat('highlight')){
                  const text = $createTextNode(' ')
                  text.setFormat(0)
                  node.append(text)
                  node.getChildren().forEach((child:any)=>{
                    child.setFormat('normal')
                  })
                }
              }
        })

        return false;
      },
      1 // Priority
    );
  }, [editor]);

  return null;
}
